import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Chip, Stack } from "@mui/material";
import "./Header.css";
import { getSiteVisitsSummary } from "../../api";

const Header = () => {
  const [isFaded, setIsFaded] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [visits, setVisits] = useState({ total: 0, today: 0 });

  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setIsFaded(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    getSiteVisitsSummary()
      .then(data => setVisits(data))
      .catch(() => setVisits({ total: 0, today: 0 }));
  }, []);

  const toggleMobileNav = () => setIsMobileNavOpen((prev) => !prev);
  const closeMobileNav = () => setIsMobileNavOpen(false);

  const handleGlobalSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      const q = e.target.value.trim();
      navigate(q ? `/places?q=${encodeURIComponent(q)}` : "/places");
      closeMobileNav();
    }
  };

  const changeLang = (lng) => i18n.changeLanguage(lng);

  return (
    <>
      <header
        className={`header-container app-header 
        ${isFaded ? "is-faded" : ""} 
        ${isRTL ? "rtl" : "ltr"}`}
        dir={isRTL ? "rtl" : "ltr"}
      >
        <div className="container topbar">

          {/* BRAND */}
          <div className="brand">
            <img
              src="/infinite.png"
              alt="logo"
              style={{ height: "48px", width: "auto" }}
            />

            <div>
              {isRTL ? (
                <>
                  <h1 className="brand-title">إنفينيت<br />بيروت الدولية</h1>
                  <p className="muted brand-subtitle">
                    صلة الوصل بين الزبون وطلبه في كافة أنحاء العالم
                  </p>
                </>
              ) : (
                <>
                  <h1 className="brand-title">{t("Header Brand Title")}</h1>
                  <p className="muted brand-subtitle">{t("Header Brand Subtitle")}</p>
                </>
              )}
            </div>
          </div>

          {/* MAIN NAV */}
          <nav
            className={`primary ${isMobileNavOpen ? "is-open" : ""}`}
            aria-label="Main navigation"
          >
            <NavLink to="/" className="nav-link" onClick={closeMobileNav}>
              {t("Header Nav Home")}
            </NavLink>

            <NavLink
              to="/countries"
              className="nav-link"
              onClick={closeMobileNav}
            >
              {t("Header Nav Countries")}
            </NavLink>

            <NavLink
              to="/categories"
              className="nav-link"
              onClick={closeMobileNav}
            >
              {t("Header Nav Categories")}
            </NavLink>

            <NavLink to="/places" className="nav-link" onClick={closeMobileNav}>
              {t("Header Nav Search")}
            </NavLink>

            <NavLink to="/ads" className="nav-link" onClick={closeMobileNav}>
              {t("Header Nav Ads")}
            </NavLink>

            <NavLink to="/about" className="nav-link" onClick={closeMobileNav}>
              {t("Header Nav About")}
            </NavLink>

            {/* <NavLink
              to="/contact"
              className="nav-link"
              onClick={closeMobileNav}
            >
              {t("Header Nav Contact")}
            </NavLink> */}

            <NavLink
              to="/post"
              className="cta nav-link"
              onClick={closeMobileNav}
            >
              {t("Header Nav Post Ad")}
            </NavLink>
          </nav>

          {/* LANG SWITCH */}
          <div className="lang-switcher">
            <button
              className={i18n.language === "en" ? "active" : ""}
              onClick={() => changeLang("en")}
            >
              EN
            </button>
            <button
              className={i18n.language === "ar" ? "active" : ""}
              onClick={() => changeLang("ar")}
            >
              AR
            </button>
          </div>

          {/* BURGER */}
          <button
            className="menu-toggle"
            onClick={toggleMobileNav}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* SEARCH BAR */}
        <div className="container">
          <div className="searchbar">
            <input
              placeholder={isRTL ? "للبحث عن إعلانك المطلوب بسرعة وسهولة اضغط" : t("Header Search Placeholder")}
              onKeyDown={handleGlobalSearchKeyDown}
            />

            <Stack direction="row" spacing={1} className="filters">
              <Chip
                label={t("Header Search All Countries")}
                clickable
                onClick={() => navigate("/countries")}
                color={isActive("/countries") ? "primary" : "default"}
              />

              <Chip
                label={t("Header Search All Categories")}
                clickable
                onClick={() => navigate("/categories")}
                color={isActive("/categories") ? "secondary" : "default"}
              />
            </Stack>
          </div>
          {/* VISITS SUMMARY CARD */}
          <div className="visits-summary-card">
            <strong>
              {t("Total Visits")}: {visits.total} | {t("Today's Visits")}: {visits.today}
            </strong>
          </div>
        </div>
      </header>

      {/* OVERLAY */}
      <div
        className={`overlay ${isMobileNavOpen ? "show" : ""}`}
        onClick={closeMobileNav}
      ></div>
    </>
  );
};

export default Header;